export default __webpack_public_path__ + "static/media/avon.202a83b7.png";